import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { REDUCER_MENU_NAME } from '#baseMenu/constants';
import { StateMenu } from '#baseMenu/types/StateMenu';

const initialState: StateMenu = {
  isVisibleButtonForAdvertContacts: false,
  isActionsBlocked: false,
  isContentLoaded: false,
  isContentLoadInProcess: false,
};

const sliceMenu = createSlice({
  name: REDUCER_MENU_NAME,
  initialState,
  reducers: {
    showButtonForAdvertContacts: (state) => {
      state.isVisibleButtonForAdvertContacts = true;
    },
    hideButtonForAdvertContacts: (state) => {
      state.isVisibleButtonForAdvertContacts = false;
    },
    blockActions: (state) => {
      state.isActionsBlocked = true;
    },
    unblockActions: (state) => {
      state.isActionsBlocked = false;
    },
    setIsContentLoaded: (state, action: PayloadAction<boolean>) => {
      state.isContentLoaded = action.payload;
    },
    setIsContentLoadInProcess: (state, action: PayloadAction<boolean>) => {
      state.isContentLoadInProcess = action.payload;
    },
  },
});

const reducerMenu = sliceMenu.reducer;

const {
  showButtonForAdvertContacts,
  hideButtonForAdvertContacts,
  blockActions,
  unblockActions,
  setIsContentLoaded,
  setIsContentLoadInProcess,
} = sliceMenu.actions;

export {
  reducerMenu,
  showButtonForAdvertContacts,
  hideButtonForAdvertContacts,
  blockActions,
  unblockActions,
  setIsContentLoadInProcess,
  setIsContentLoaded,
};
